import script from "./CoachAbsentPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoachAbsentPopup.vue?vue&type=script&setup=true&lang=ts"

import "./CoachAbsentPopup.vue?vue&type=style&index=0&id=0bce7236&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bce7236"]])

export default __exports__